import { GetServerSideProps } from 'next';

import { getProcessEnvs, PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { mockModel } from '../mocks/mockModel';
import landingpageSignatures from '../signatures/landingpageSignatures.json';

import { NEXT_PUBLIC_ENV_KEYS } from '@marriott/mi-landingpage-components';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';

function pageRenderer(props) {
  console.log('[page] props ', props);
  return <PageRendererComponent {...props} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const landingpageSpecificData = async () => {
  const [featureFlagLogo, featureFlagAemltsHost] = await Promise.all([
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LOGO_AUTOMATION, {
      target: TARGETS.APP.LANDINGPAGE_RENDERER,
    }),
    fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_LEISURE_RENDERER_AEMLTS_HOST, {}),
  ]);

  const useAemLtsHost = featureFlagAemltsHost?.experience_mcom_leisure_renderer_aemlts_host;
  const aemHost = useAemLtsHost ? process.env.NEXT_PUBLIC_AEM_LTS_HOST : process.env.NEXT_PUBLIC_AEM_HOST;
  const { GOOGLE_MAP_API_KEY } = getProcessEnvs();

  return {
    operationSignatures: landingpageSignatures,
    featureFlagAemltsHost: featureFlagAemltsHost ?? null,
    aemHost: aemHost ?? null,
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
    GOOGLE_MAP_API_KEY,
    featureFlags: { featureFlagLogo },
  };
};

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(landingpageSpecificData, mockModel);
export default pageRenderer;
